import { DIALOGS } from "components/Dialogs/constants";
import { LocationPayload, mergeWithCurrentLocation } from "ducks/location/location";
import { createAction, createReducer } from "redux-act";
import { reducerRegistry } from "../reducerRegistry";
import { currentDialogState, dialogsState } from "./selectors";

export const reducerName = "dialogs";

type ResourceName = string;

export interface DialogsState {
  resources?: ResourceName[];
  options?: Record<string, unknown>;
  child?: DialogsState[];
  id?: string;
  type?: DIALOGS;
}

const initialState: DialogsState = { resources: [], options: {} };

export const reducer = createReducer({}, initialState);

export const setDialogResources = createAction<DialogsState>("dialogs/set-dialog-resources");
export const openDialogChild = createAction<DialogsState>("dialogs/open-dialog-child");
export const closeDialogChild = createAction<string>("dialogs/open-dialog-child");

reducer.on(setDialogResources, (state, dialogState) => ({
  ...dialogState,
}));

reducer.on(openDialogChild, (state, dialogState) => ({
  ...state,
  child: [...(state.child || []), dialogState],
}));

reducer.on(closeDialogChild, (state, idToDelete) => ({
  ...state,
  child: state.child?.filter(({ type }) => type !== idToDelete),
}));

export const setCurrentDialog =
  (dialog: DIALOGS, dialogOptions: DialogsState = {}, args: LocationPayload = {}) =>
  (dispatch, getState) => {
    const currentDialog = currentDialogState(getState());

    if (currentDialog?.type) {
      dispatch(openDialogChild({ ...dialogOptions, type: dialog }));
    } else {
      dispatch(
        mergeWithCurrentLocation({
          payload: args,
          query: {
            dialog,
          },
        }),
      );

      dispatch(setDialogResources({ ...dialogOptions, type: dialog }));
    }
  };

export const resetDialog = () => (dispatch, getState) => {
  const currentDialogsState = dialogsState(getState());

  if (currentDialogsState?.child?.length > 0) {
    dispatch(closeDialogChild(currentDialogsState.child[currentDialogsState.child.length - 1].type));
  } else {
    dispatch(
      mergeWithCurrentLocation({
        query: {
          dialog: void 0,
        },
      }),
    );

    dispatch(setDialogResources({ resources: [], options: {} }));
  }
};

reducerRegistry.register(reducerName, reducer);
